/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_LatitudeInputs */

const cs_form_latitude = /** @type {(inputs: Form_LatitudeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeměpisná šířka`)
};

const en_form_latitude = /** @type {(inputs: Form_LatitudeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latitude`)
};

/**
* | output |
* | --- |
* | "Latitude" |
*
* @param {Form_LatitudeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_latitude = /** @type {((inputs?: Form_LatitudeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_LatitudeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_latitude(inputs)
	return cs_form_latitude(inputs)
});